import React from 'react';

const ShapesBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden opacity-60">
      {/* Radial gradients for depth */}
      {/* <div 
        className="absolute top-0 right-0 w-[600px] h-[600px] animate-pulse-slow"
        style={{
          background: 'radial-gradient(circle, rgba(59, 130, 246, 0.2) 0%, rgba(59, 130, 246, 0.1) 50%, transparent 100%)'
        }}
      />
      <div 
        className="absolute bottom-0 left-0 w-[500px] h-[500px] animate-pulse-delay"
        style={{
          background: 'radial-gradient(circle, rgba(96, 165, 250, 0.15) 0%, rgba(96, 165, 250, 0.08) 50%, transparent 100%)'
        }}
      /> */}
      
      {/* Large circles with different rotations */}
      <div className="absolute -right-20 -top-20 w-[400px] h-[400px] rounded-full border-2 border-primary-500/10 dark:border-white/10 animate-slow-spin" />
      <div className="absolute -right-10 -top-10 w-[300px] h-[300px] rounded-full border-2 border-primary-500/10 dark:border-white/10 animate-reverse-spin" />
      <div className="absolute -left-16 -bottom-16 w-[350px] h-[350px] rounded-full border border-primary-400/10 dark:border-white/5 animate-slow-spin" />
      
      {/* Floating geometric shapes - repositioned to avoid overlap */}
      <div className="hidden lg:block absolute top-1/4 left-20 w-32 h-32 rotate-45 border-2 border-primary-500/10 dark:border-white/10 animate-float-slow rounded-lg" />
      <div className="absolute bottom-32 right-1/4 w-40 h-40 rotate-12 border-2 border-primary-500/10 dark:border-white/10 animate-float-delay rounded-lg" />
      <div className="absolute top-1/10 left-1/4 w-24 h-24 rotate-90 border border-primary-400/10 dark:border-white/5 animate-float rounded-lg" />
      
      {/* Hexagons and diamonds - repositioned */}
      <div className="absolute top-1/5 right-1/10 w-20 h-20 rotate-45 border border-primary-300/5 dark:border-white/5 animate-float-slow rounded-md" />
      <div className="absolute bottom-1/10 left-1/4 w-16 h-16 rotate-30 border border-blue-400/10 dark:border-blue-300/5 animate-float-delay rounded-md" />
      
      {/* Filled shapes with gradients */}
      {/* <div className="absolute top-1/10 right-1/4 w-64 h-64 rounded-full bg-gradient-to-br from-primary-500/5 to-primary-400/10 animate-pulse-slow" />
      <div className="absolute bottom-1/4 left-1/4 w-48 h-48 rotate-45 bg-gradient-to-br from-blue-400/5 to-blue-300/10 animate-float" />
      <div className="absolute top-1/4 right-1/10 w-32 h-32 rounded-full bg-gradient-to-br from-purple-400/4 to-purple-300/5 animate-pulse-delay" /> */}
      
      {/* Small animated elements */}
      <div className="absolute top-1/5 left-32 w-3 h-12 rotate-45 bg-gradient-to-b from-primary-500/10 to-primary-400/10 dark:from-white/10 dark:to-white/5 animate-float-delay rounded-sm" />
      <div className="absolute bottom-1/10 right-48 w-12 h-3 -rotate-12 bg-gradient-to-r from-primary-500/10 to-primary-400/10 dark:from-white/10 dark:to-white/5 animate-float-slow rounded-sm" />
      <div className="absolute top-1/4 right-1/4 w-6 h-6 rounded-full bg-gradient-to-br from-primary-500/10 to-primary-400/10 dark:from-white/10 dark:to-white/5 animate-pulse" />
      
      {/* Additional small geometric elements - repositioned */}
      <div className="absolute top-2/10 left-1/5 w-8 h-8 rotate-45 border border-primary-300/5 dark:border-white/5 animate-float rounded-md" />
      <div className="absolute bottom-1/4 right-1/5 w-10 h-10 rotate-60 border border-blue-400/10 dark:border-blue-300/5 animate-float-slow rounded-md" />
      <div className="absolute top-1/5 right-1/5 w-4 h-4 rounded-full bg-gradient-to-br from-purple-400/10 to-purple-300/5 animate-pulse-delay" />
      
      {/* Floating dots */}
      <div className="absolute top-1/10 left-1/5 w-2 h-2 rounded-full bg-primary-400/50 dark:bg-white/15 animate-float" />
      <div className="absolute bottom-1/5 right-1/10 w-1.5 h-1.5 rounded-full bg-blue-400/55 dark:bg-blue-300/50 animate-float-delay" />
      <div className="absolute top-2/10 right-1/5 w-1 h-1 rounded-full bg-purple-400/100 dark:bg-purple-300/55 animate-float-slow" />
      
      {/* Subtle grid lines */}
      <div className="absolute inset-0 opacity-[0.02] dark:opacity-[0.008]">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-500/50 to-transparent" />
        <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-400/15 to-transparent" />
        <div className="absolute top-1/5 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-300/10 to-transparent" />
        <div className="absolute top-3/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-400/15 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-500/50 to-transparent" />
      </div>
      
      {/* Corner accents */}
      <div className="absolute top-8 right-8 w-16 h-16 border-t-2 border-r-2 border-primary-400/50 dark:border-white/10 animate-pulse-slow" />
      <div className="absolute bottom-8 left-8 w-12 h-12 border-b-2 border-l-2 border-blue-400/50 dark:border-blue-300/10 animate-pulse-delay" />
    </div>
  );
};

export default ShapesBackground; 